import { Hero } from "@/sections/Hero";
import { TrustStats } from "@/sections/TrustStats";
import { Marquee } from "@/components/Marquee";
import { AboutPreview, ServicesPreview, WhyUs } from "@/sections/HomeMain";
import { ProcessPreview, ProjectsPreview } from "@/sections/HomeWork";
import { MaterialsSection, TurnkeySection, FoundersSection } from "@/sections/HomeTrust";
import { TestimonialsSection, FaqSection, ServiceAreasSection, FinalCta } from "@/sections/HomeVoice";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStats />
      <Marquee />
      <AboutPreview />
      <ServicesPreview />
      <WhyUs />
      <ProcessPreview />
      <ProjectsPreview />
      <MaterialsSection />
      <TurnkeySection />
      <FoundersSection />
      <TestimonialsSection />
      <FaqSection />
      <ServiceAreasSection />
      <FinalCta />
    </>
  );
}
